/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetCachedContentModel,
  IGetCachedContentRequest,
  IMappers,
  IGetCachedContentResponse,
  IGetCachedContentResponseError,
  TGetCachedContentResponse,
} from './types';

const defaultConfig: TGetCachedContentModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'special-promos-custom',
  pathApi: '/v1/get-cached-content/',
  hostType: 'api',
} as TGetCachedContentModel;

function createGetCachedContentModel(parameters: IGetCachedContentRequest): TGetCachedContentModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetCachedContentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetCachedContentRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetCachedContent<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetCachedContentOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetCachedContentResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetCachedContentModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetCachedContentResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetCachedContentResponseError);
    }
  }

  return { response, statusCode } as TGetCachedContentResponse;
}

export { defaultConfig, createGetCachedContentModel, fetchGetCachedContent };
